export default class extends HTMLElement {
  connectedCallback () {
    // Defer initialization to ensure child elements are available
    // (fixes Turbo Frame rendering timing where children may not be parsed yet)
    requestAnimationFrame(() => {
      this.adminCheckbox = this.querySelector('#user_is_admin')
      this.entityList = this.querySelector('#entity_access_list')
      this.entitySelectsContainer = this.querySelector('[data-entity-assignments]')
      this.form = this.closest('form')

      if (!this.adminCheckbox || !this.entityList) return

      this.adminCheckbox.addEventListener('change', () => {
        this.toggleEntityAccess()
      })

      // Validate on form submit
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          if (!this.validateForm()) {
            e.preventDefault()
          }
        })
      }

      // Initial state
      this.toggleEntityAccess()
    })
  }

  toggleEntityAccess () {
    const isAdmin = this.adminCheckbox.checked
    const checkboxes = this.entityList.querySelectorAll('.entity-checkbox')
    const selects = this.entityList.querySelectorAll('.entity-role')
    const labels = this.entityList.querySelectorAll('.entity-label')
    const errorEl = document.getElementById('entity_access_error')

    checkboxes.forEach((cb) => {
      cb.disabled = isAdmin
      if (isAdmin) cb.checked = false
    })

    selects.forEach((sel) => {
      sel.disabled = isAdmin
    })

    labels.forEach((label) => {
      label.classList.toggle('opacity-40', isAdmin)
      label.classList.toggle('cursor-not-allowed', isAdmin)
    })

    // Gray out the whole entity access section when admin is checked
    if (this.entitySelectsContainer) {
      this.entitySelectsContainer.classList.toggle('opacity-50', isAdmin)
    }

    if (errorEl) {
      errorEl.classList.add('hidden')
    }
  }

  validateForm () {
    const isAdmin = this.adminCheckbox.checked
    const errorEl = document.getElementById('entity_access_error')

    if (isAdmin) {
      if (errorEl) errorEl.classList.add('hidden')
      return true
    }

    // Must select at least one entity if not admin
    const checkedCount = this.entityList.querySelectorAll('.entity-checkbox:checked').length
    if (checkedCount === 0) {
      if (errorEl) errorEl.classList.remove('hidden')
      return false
    }

    if (errorEl) errorEl.classList.add('hidden')
    return true
  }
}
